/**
 * Actions designed for persistent editing of a selected exploration
 */

export enum ActiveExplorationActionType {
  ViewChartData = '[Exploration] ViewChartData',

  // Success/failure actions
  UpdateExplorationSuccess = '[Exploration] UpdateExplorationSuccess',
}
